import { useNavigate } from "react-router-dom";
import Nav from "./Nav.jsx";
import Footer from "./Footer.jsx";
import "./home.css";
import StandardExpressList from "../Components/ListpageExpress";
import { workOrders } from "../HelperFx/datalinks.js";
import verifyToken from "../HelperFx/verifyJwt.js";

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;

const WorkOrders = () => {
  const navigate = useNavigate();
  const token = btoa(`${REACT_UNAME}:${REACT_PWD}`);
  const { custName } = verifyToken(sessionStorage.getItem("authToken")) || {};
  const apiUrl = `${REACT_DATA_URL}${workOrders}?${REACT_APP_COMPANY_URL}&$filter=workOrderType eq 'WorkOrder' and customerNo eq '${custName}'`;

  const columns = [
    {
      name: "No.",
      selector: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => navigate("/WorkOrder", { state: { number: row.no } })}
        >
          {row.no}
        </span>
      ),
      sortable: true,
    },
    { name: "Machine Type", selector: (row) => row.machineType, sortable: true },
    { name: "Machine No", selector: (row) => row.machineNo, sortable: true },
    { name: "Machine Name", selector: (row) => row.machine, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Maintenance Type",
      selector: (row) => row.maintenanceType,
      sortable: true,
    },
    { name: "Start Date", selector: (row) => row.startDate, sortable: true },
    {
      name: "Completion Date",
      selector: (row) => row.completionDate,
      sortable: true,
    },
  ];

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <StandardExpressList
          apiUrl={apiUrl}
          token={token}
          columns={columns}
          searchKeys={["no", "machineNo", "machine", "maintenanceType", "status"]}
          pageCaption="Field Work Orders"
          actionvisibility={false}
          redirectTo="home"
          infiniteScroll
        />
      </div>
      <Footer />
    </div>
  );
};

export default WorkOrders;
